import { createContext, useContext } from 'react';

export const IsKWLPContext = createContext(false);

export const useIsKWLP = () => useContext(IsKWLPContext);
